import Vue from 'vue'
import App from './App.vue'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
Vue.config.productionTip = false


const store = {
  state: {
    queryString: "",
    results: {}
  },
  addVehicles(vehicles) {
    this.state.results = vehicles

  },
  changeQuery(query) {
    this.state.queryString = (query ? query : "")
  },
  appendVehicles(vehicles) {

    this.state.results.data = this.state.results.data.concat(vehicles.data)

    this.state.results.pagination = vehicles.pagination


  }
};
Vue.prototype.$store = store
new Vue({
  render: h => h(App),
}).$mount('#app')
